import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const DeleteRestaurantModal = ({ isOpen, onClose, restaurant }) => {
  const [restaurantName, setRestaurantName] = useState('');
  const navigate = useNavigate();

  const formatRestaurantName = (name) => {
    return name.toLowerCase().trim().split(" ").join("-");
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_API_URL}/api/back-office/restaurants/${restaurant.id}/delete`,
        {
          data: {
            restaurantName: formatRestaurantName(restaurantName)
          }
        }
      );

      toast.success('Restaurant supprimé avec succès', {
        position: 'top-center',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        theme: 'colored',
      });

      // Rediriger vers la page d'accueil du back-office après la suppression
      setTimeout(() => {
        navigate('/back-office');
      }, 1500);
    } catch (error) {
      const message = error.response?.data?.message || 'Une erreur est survenue lors de la suppression';
      toast.error(message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        theme: 'colored',
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Supprimer le restaurant</h2>
        <p className="mb-4">
          Cette action est irréversible. Pour confirmer la suppression, veuillez saisir le nom du restaurant :
          <span className="font-bold"> {restaurant?.name}</span>
        </p>
        <input
          type="text"
          value={restaurantName}
          onChange={(e) => setRestaurantName(e.target.value)}
          placeholder="Nom du restaurant"
          className="w-full p-2 border border-gray-300 rounded mb-4"
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            className={`px-4 py-2 text-white rounded ${restaurantName !== restaurant?.name ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
            disabled={restaurantName !== restaurant?.name}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRestaurantModal; 